import { useSelector } from 'react-redux';
import axiosInstance from 'config/AxiosConfig';
import { BaseResponse } from 'domain/payload/response/BaseResponseDto';
import { ContractListResp } from 'domain/payload/response/contract/ContractListResp';
import { ContractDetailResp } from 'domain/payload/response/contract/ContractDetailResp';

const ContractService = () => {
  const { token } = useSelector((state: any) => state.auth);

  const contractList = async (
    page: number,
    size: number,
    status?: string | number,
  ): Promise<BaseResponse<ContractListResp[]>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/contract/list`, {
        headers: {
          ...axiosInstance.defaults.headers.head,
          Authorization: `Bearer ${token}`,
        },
        params: { page, size, status },
      });
      return response.data;
    } catch (error: any) {
      console.error(error.response?.data?.message);
      throw error.response?.data?.message;
    }
  };

  const contractDetail = async (
    id: string,
  ): Promise<BaseResponse<ContractDetailResp>> => {
    try {
      const response = await axiosInstance.get(
        `/v1/legacy/contract/detail`,
        {
          headers: {
            ...axiosInstance.defaults.headers.head,
            Authorization: `Bearer ${token}`,
          },
          params: { id },
        },
      );
      return response.data;
    } catch (error: any) {
      console.error(error.response?.data?.message);
      throw error.response?.data?.message;
    }
  };

  return { contractList, contractDetail };
};

export default ContractService;
